module.exports = __webpack_public_path__ + "static/media/eyat.9115e9f4.jpg";